export default "__VITE_PUBLIC_ASSET__51ece921__"